import { Component, h, render } from "preact";
import {
  shouldPageRedirect,
  extractLocationFromUrl,
  convertStateToAbbreviation,
  sortSchoolsByLikenessToMatch,
  convertSlugToStartCase,
} from "./lib";
import { fetchSchools } from "./api";

class App extends Component {
  constructor() {
    super();
    this.state = {
      shouldRedirect: false,
      city: null,
      state: null,
      school: null,
      options: [],
    };
  }

  componentDidMount() {
    const url = window.location;
    if (shouldPageRedirect(url)) {
      const location = extractLocationFromUrl(url);

      this.setState({
        ...{ shouldRedirect: true },
        ...location,
      });
      fetchSchools(location.city, convertStateToAbbreviation(location.state))
        .then((r) => r.json())
        .then((data) => {
          if (location.school) {
            return sortSchoolsByLikenessToMatch(
              data.schools,
              convertSlugToStartCase(location.school)
            );
          }
          return data.schools;
        })
        .then((schools) => {
          this.setState({ options: schools });
        });
    }
  }

  render() {
    return (
      <div style={{ marginBottom: this.state.shouldRedirect ? "1.5rem" : "0" }}>
        <p>{this.state.shouldRedirect ? "Were you looking for?" : ""}</p>
        <ul>
          {this.state.options.map(function (option) {
            return (
              <li>
                <a href={option.url}>{option.name}</a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

render(<App />, document.querySelector("#jostens-redirect-app"));
